import { ChatInfo, initChatInfo, updateChatInfo } from '@modules/chat';
import { useCallback } from 'react';
import { useDispatch } from '@store';

const useChat = () => {
  const dispatch = useDispatch();

  const onInitChatInfo = useCallback(() => dispatch(initChatInfo()), [
    dispatch
  ]);

  const onUpdateChatInfo = useCallback(
    (payload: ChatInfo) => dispatch(updateChatInfo(payload)),
    [dispatch]
  );

  return {
    onInitChatInfo,
    onUpdateChatInfo
  };
};

export default useChat;
